// extracted by mini-css-extract-plugin
export default {"portfolioBox":"Portfolio_portfolioBox__Zvlwd"};